import { render, staticRenderFns } from "./appServiceConfig.vue?vue&type=template&id=73f0af64&scoped=true&"
import script from "./appServiceConfig.vue?vue&type=script&lang=js&"
export * from "./appServiceConfig.vue?vue&type=script&lang=js&"
import style0 from "./appServiceConfig.vue?vue&type=style&index=0&id=73f0af64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f0af64",
  null
  
)

export default component.exports